import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = ({ type = 'table', rows = 8 }) => {
  if (type === 'table') {
    return (
      <div className="skeleton-table-container">
        <div className="skeleton-table-header">
          <div className="skeleton-row skeleton-header-row">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="skeleton-cell skeleton-header-cell">
                <div className="skeleton-shimmer" />
              </div>
            ))}
          </div>
        </div>
        <div className="skeleton-table-body">
          {[...Array(rows)].map((_, rowIndex) => (
            <div key={rowIndex} className="skeleton-row">
              {[...Array(6)].map((_, cellIndex) => (
                <div key={cellIndex} className="skeleton-cell">
                  <div className="skeleton-shimmer" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'dashboard') {
    return (
      <div className="skeleton-dashboard-container">
        <div className="skeleton-dashboard-header">
          <div className="skeleton-title">
            <div className="skeleton-shimmer" />
          </div>
          <div className="skeleton-actions">
            <div className="skeleton-button">
              <div className="skeleton-shimmer" />
            </div>
          </div>
        </div>
        <div className="skeleton-stats-grid">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="skeleton-stat-card">
              <div className="skeleton-shimmer" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Default minimal loader
  return (
    <div className="skeleton-minimal">
      <div className="skeleton-spinner" />
    </div>
  );
};

export default SkeletonLoader;
